export const AppConstant = {
  defaultAppBackgroundColor: '#f0f2f8',
  i2i: {
    emails: {
      support: 'support@i2iconnect.com',
    },
  },
} as const;
